import { queryOptions, useQuery } from "@tanstack/react-query";
import { api } from "../apiClient";

export const getAttendanceBusSchedules = ({ attendanceId }) => {
  return api.get(`admin/attendance-bus-schedules/${attendanceId}`);
};

export const getAttendanceBusSchedulesQueryOptions = params => {
  return queryOptions({
    queryKey: ["attendance-bus-schedules", params],
    queryFn: () => getAttendanceBusSchedules(params),
  });
};

export const useAttendanceBusSchedulesQuery = ({
  queryConfig = {},
  ...params
}) => {
  return useQuery({
    ...getAttendanceBusSchedulesQueryOptions(params),
    ...queryConfig,
  });
};
